module.exports = __webpack_public_path__ + "static/media/discussion-topic-hero.38c26f4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/discussion-topic-hero.jpg
// module id = 748
// module chunks = 0